import { RootReducerType } from "../CombineReducer";

export const useGetUserList = (state: RootReducerType) => state.users.userList;
export const useGetUserListLoading = (state: RootReducerType) => state.users.isLoading;
